document.addEventListener("DOMContentLoaded", () => {

  const tabs = document.querySelectorAll(".shop-by-concern .tab");
  const categories = document.querySelectorAll(".shop-by-concern .categories");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      tabs.forEach((tab) => tab.classList.remove("active"));
      tab.classList.add("active");

      categories.forEach((subcategory) =>
        subcategory.classList.remove("active")
      );

      if (categories[index]) {
        categories[index].classList.add("active");

        const firstCategoryButton = categories[index].querySelector("button");
        if (firstCategoryButton) {
          firstCategoryButton.click();
        }
      }
    });
  });

  if (tabs.length > 0 && categories.length > 0) {
    tabs[0].classList.add("active");
    categories[0].classList.add("active");

    const firstCategoryButton = categories[0].querySelector("button");
    if (firstCategoryButton) {
      firstCategoryButton.click();
    }
  }

  const categoryButtons = document.querySelectorAll(".categories button");
  const subcategoryContainers = document.querySelectorAll(".subcategories");

  categoryButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const selectedTag = button.getAttribute("data-tag");

      categoryButtons.forEach((btn) => btn.classList.remove("active"));

      button.classList.add("active");

      subcategoryContainers.forEach((container) => {
        container.style.display = "none";
        container.classList.remove("active");
      });
      const matchingSubcategory = document.querySelector(
        `.subcategories[data-tag="${selectedTag}"]`
      );
      if (matchingSubcategory) {
        matchingSubcategory.style.display = "flex";
        matchingSubcategory.classList.add("active");
      }
    });
  });

  document.querySelectorAll(".sub-category-slider").forEach(function (slider) {
    new Splide(slider, {
      type: "slide",
      perPage: 3,
      perMove: 1,
      pagination: false,
      arrows: true,
      gap: "40px",
      drag: true,
      padding: { left: "0rem", right: "8rem" },
      breakpoints: {
        768: {
          arrows: false,
          perPage: 1,
          perMove: 1,
          padding: { left: "0rem", right: "2.3rem" },
          gap: "16px",

        },
      },
    }).mount();
  });

  const container = document.getElementById('health-categories');

  let isDown = false;         // Is mouse pressed?
  let isDragging = false;     // Did the user drag beyond the threshold?
  let startX;                 // Mousedown X
  let startY;                 // Mousedown Y
  let scrollLeft;             // Container's scroll position at mousedown
  const DRAG_THRESHOLD = 5;   // Pixels to move before considering it a "drag"

  container.addEventListener('mousedown', (e) => {
    isDown = true;
    isDragging = false;        // reset each time
    startX = e.pageX;
    startY = e.pageY;
    scrollLeft = container.scrollLeft;
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDown) return;       // Only move if mouse is down

    // Calculate how far the pointer has moved since mousedown
    const dx = e.pageX - startX;
    const dy = e.pageY - startY;

    // If movement surpasses threshold, consider it a drag
    if (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD) {
      isDragging = true;
      container.classList.add('dragging');  // Switch cursor to grabbing
    }

    // Only scroll if we're actually dragging
    if (isDragging) {
      e.preventDefault();                    // Prevent text selection
      container.scrollLeft = scrollLeft - dx;
    }
  });

  document.addEventListener('mouseup', () => {
    isDown = false;
    container.classList.remove('dragging');
  });

  // Handle click on buttons
  document.querySelectorAll('#health-categories button').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      // If user actually dragged, cancel the click
      if (isDragging) {
        e.preventDefault();
        e.stopImmediatePropagation();
        // do nothing else
      } else {
        // Otherwise, this is a valid click
        // (your normal button click logic here)
        // console.log(`Button clicked: ${btn.textContent.trim()}`);
      }
    });
  });
  const shopByConcernSection = document.querySelector('.shop-by-concern');
  
  // If the section doesn't exist on this page, exit early
  if (!shopByConcernSection) return;
  
  // Flag to ensure initialization happens only once
  let hasInitialized = false;
  
  // Function to check scroll position and initialize if needed
  function checkScrollAndInit() {
    if (!hasInitialized && window.scrollY >= 200) {
      initShopByConcern();
      hasInitialized = true;
      // Remove the scroll listener once initialized
      window.removeEventListener('scroll', checkScrollAndInit);
    }
  }
  
  // Add scroll event listener
  window.addEventListener('scroll', checkScrollAndInit);
  
  // Also check immediately in case we're already scrolled down
  checkScrollAndInit();
  
  function initShopByConcern() {
    // Track which collections have already been successfully loaded
    const loadedCollections = new Set();

    // Get all subcategory containers with collection handles
    const collectionSubcategories = document.querySelectorAll('.fetch-subcategories[data-collection-handle]');
    
    // Process each subcategory container
    collectionSubcategories.forEach(subcategoryDiv => {
      const collectionHandle = subcategoryDiv.dataset.collectionHandle;
      
      if (collectionHandle && !loadedCollections.has(collectionHandle)) {
        // Find the splide__list inside this subcategory
        const splideList = subcategoryDiv.querySelector('.splide__list');
        
        if (splideList) {
          // Show loading state
          splideList.innerHTML = '<div class="loading">Loading products...</div>';
          
          // Fetch the collection page
          fetch(`/collections/${collectionHandle}`)
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then(html => {
              // Parse the HTML response
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              // Find the CollectionLoop element
              const collectionLoop = doc.getElementById('CollectionLoop');
              
              // Function to process product items and create slides
              const processProducts = (productItems) => {
                if (productItems.length > 0) {
                  // Clear loading message
                  splideList.innerHTML = '';
                  
                  // Create a splide slide for each product
                  productItems.forEach(item => {
                    const slide = document.createElement('div');
                    slide.className = 'splide__slide';
                    slide.innerHTML = item.outerHTML;
                    splideList.appendChild(slide);
                  });
                  
                  // If using Splide library, initialize the slider
                  if (typeof Splide !== 'undefined' && splideList.closest('.splide')) {
                    const splideInstance = new Splide(splideList.closest('.splide'), {
                      perPage: 3,
                      perMove: 1,
                      pagination: false,
                      arrows: true,
                      gap: "40px",
                      drag: true,
                      padding: { left: "0rem", right: "8rem" },
                      breakpoints: {
                        768: {
                          arrows: false,
                          perPage: 1,
                          perMove: 1,
                          padding: { left: "0rem", right: "2.3rem" },
                          gap: "16px",
                
                        },
                      }
                    });
                    splideInstance.mount();
                  }
                  
                  // Mark this collection as successfully loaded
                  loadedCollections.add(collectionHandle);
                } else {
                  splideList.innerHTML = '<div class="no-products">No products found in this collection</div>';
                }
              };
              
              if (collectionLoop) {
                // Find all product items in the CollectionLoop
                const productItems = collectionLoop.querySelectorAll('.product-item, [class*="product-grid-item"]');
                processProducts(productItems);
              } else {
                // If CollectionLoop isn't found, try to find products directly
                const productItems = doc.querySelectorAll('.product-item, [class*="product-grid-item"]');
                processProducts(productItems);
              }
            })
            .catch(error => {
              console.error(`Error fetching collection ${collectionHandle}:`, error);
              splideList.innerHTML = '<div class="error">Error loading products</div>';
            });
        }
      }
    });
    
    // Initialize active states for UI if needed
    const firstTab = document.querySelector('.shop-by-concern .tab');
    const firstCategory = document.querySelector('.shop-by-concern .categories');
    const firstCategoryButton = document.querySelector('.categories button');
    
    if (firstTab) firstTab.classList.add('active');
    if (firstCategory) firstCategory.classList.add('active');
    if (firstCategoryButton) firstCategoryButton.classList.add('active');
  }
});